export default __webpack_public_path__ + "static/media/pan_tool.b2592590.svg";